import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
// This is done
const UsePersonalInfo = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>How We Use Your Personal Information</h3>

      <p>
        We use personal information to provide, operate, maintain, secure, and
        improve our website, training platform, and services. We may use your
        information for the following purposes:
      </p>

      <ul>
        <li>
          <strong>
            To process transactions and provide purchased services:
          </strong>{' '}
          This includes processing transactions through Stripe or other
          authorized payment processors, confirming purchases, maintaining
          transaction records, providing access to purchased courses or
          subscriptions, and assigning purchased training to users.
        </li>
        <li>
          <strong>To create and manage accounts:</strong> This includes creating
          and maintaining individual and company accounts, authenticating users,
          resetting passwords, managing account permissions, and providing
          account-related support.
        </li>
        <li>
          <strong>To provide and administer online training:</strong> This
          includes providing access to courses, quizzes, assessments, and
          training materials; tracking course progress and completion; recording
          quiz or assessment results; maintaining training records; and
          generating and providing access to certificates.
        </li>
        <li>
          <strong>To support company training management:</strong> This includes
          allowing authorized company managers or representatives to add and
          manage users, purchase and assign training, monitor training status
          and completion, and access training records or certificates available
          through their company account.
        </li>
        <li>
          <strong>To provide digital safety forms and documentation:</strong>{' '}
          This includes providing access to digital safety forms, storing
          submitted form entries, making authorized entries available through
          the platform, and providing access to safety manuals and other
          workplace documentation.
        </li>
        <li>
          <strong>To manage subscriptions and access permissions:</strong> This
          includes maintaining access to subscription-based services and
          controlling access to forms, manuals, training materials, and other
          platform resources based on account roles and permissions.
        </li>
        <li>
          <strong>To send service-related communications:</strong> This includes
          account and security communications, password resets, purchase
          confirmations, course assignments, training-related notifications,
          certificate-related communications, training expiration or renewal
          reminders, and other messages necessary to provide or administer our
          services.
        </li>
        <li>
          <strong>To send newsletters and promotional communications:</strong>{' '}
          Where you have subscribed or otherwise provided the required consent,
          we may use your contact information to send newsletters, service
          updates, promotions, or other marketing communications. You may
          unsubscribe from these communications using the unsubscribe method
          provided.
        </li>
        <li>
          <strong>To respond to inquiries and provide support:</strong> This
          includes responding to questions or requests relating to training,
          accounts, safety products, custom documentation, technical support,
          and other Yoda Safety Services products or services.
        </li>
        <li>
          <strong>To operate, secure, and improve our platform:</strong> This
          may include troubleshooting technical issues, maintaining platform
          security, preventing unauthorized access or misuse, analyzing how our
          website and platform are used, and improving functionality and user
          experience.
        </li>
        <li>
          <strong>To maintain business and legal records:</strong> This includes
          maintaining records where reasonably necessary for accounting, tax,
          regulatory, contractual, dispute resolution, fraud prevention,
          security, or other legal and business purposes.
        </li>
        <li>
          <strong>
            To enforce our agreements and comply with legal obligations:
          </strong>{' '}
          We may use information as reasonably necessary to enforce our Terms
          and Conditions, protect our rights or the rights of others, and comply
          with applicable laws, regulations, legal processes, or lawful
          requests.
        </li>
      </ul>

      <p>
        We will use personal information for the purposes described in this
        Privacy Policy, for purposes identified when the information is
        collected, or as otherwise permitted or required by law. If we intend to
        use personal information for a materially different purpose, we will
        obtain additional consent where required by applicable law.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default UsePersonalInfo;
